import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();
  return (
    <li>
      {/* <a 
          className="nav-link" 
          href="#"
          onClick={() => {
            return loginWithRedirect(
              {
                appState: {
                  returnTo: location.pathname
                }
            });
          }}
        >Login</a> */}
      <button
        type="button"
        className="btn btn-primary btn-sm ms-2"
        onClick={() => {
          return loginWithRedirect(
            {
              appState: {
                returnTo: location.pathname
              }
          });
        }}
        style={{ minWidth: '80px' }}
      >
        Login
      </button>
    </li>
  )
}
export default LoginButton;